$(function() {
  var breakPoint = 767;

  //レスポンシブ時の画像切り替え
  $(function () {
    var $elem = $('.rsp');
    var sp = '_sp.';
    var pc = '_pc.';

    function imageSwitch() {
      var windowWidth = parseInt($(window).width());
      $elem.each(function () {
      var $this = $(this);
        if (windowWidth <= breakPoint) {
          $this.attr('src', $this.attr('src').replace(pc, sp));
        } else {
          $this.attr('src', $this.attr('src').replace(sp, pc));
        }
      });
    }
    imageSwitch();

    //ディレイ設定
    var delayStart;
    var delayTime = 0;
    $(window).on('resize', function () {
      clearTimeout(delayStart);
      delayStart = setTimeout(function () {
      imageSwitch();
      }, delayTime);
    });
  });

});

